<h1>Complete Shift</h1>
<div class="steps">
    <p-steps #steps [model]="items | async" [activeIndex]="activeItemIndex | async">
        <ng-template pTemplate="item" let-item let-i="index">
            <div style="position: relative; text-align: center; min-width: 10em">
              <div class="ui-menuitem-text">
                {{item.label}}
              </div>
            </div>
        </ng-template>
    </p-steps>
</div>

<router-outlet></router-outlet>

<p-card>
  <div class="form-buttons">
    <button pButton
      label="Previous"
      (click)="previousPage()"
      [disabled]="!(childIsValid | async)"
      icon="pi pi-angle-left">
    </button>
    <button pButton
      label="{{(isLastPage | async) ? 'Complete' : 'Next'}}"
      (click)="nextPage()"
      [disabled]="!nextPreloaded || !(childIsValid | async)"
      icon="{{!nextPreloaded? 'pi pi-spin pi-spinner' :'pi pi-angle-right'}}"
      pTooltip="{{!nextPreloaded ? 'Loading Next Page Content...' : 'Next Page'}}">
    </button>
  </div>
</p-card>

<p-dialog header="Complete Shift" [(visible)]="displayCompleteShiftModal" [modal]="true" (onHide)="closeCompleteShiftPopup()">
  <div class="p-grid">
    <div class="p-col">
      <p *ngIf="(context | async)?.status === ShiftStatus.Open">
        Are you sure you want to close {{(context | async).date.toLocaleString()}} shift {{(context | async).shift.number}}?
      </p>
      <p *ngIf="(context | async)?.status !== ShiftStatus.Open">
        <p-message
          severity="warn"
          closeable="false"
          text="Cannot close {{(context | async)?.date.toLocaleString()}} shift {{(context | async)?.shift.number}} because it is already closed.">
        </p-message>
      </p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton
      label="Cancel"
      ng-required="required"
      class="p-button-info"
      [disabled]="closingShift"
      (click)="closeCompleteShiftPopup()"></button>
    <button pButton
      label="Close Shift"
      [icon]="closingShift ? 'pi pi-spin pi-spinner' : 'pi pi-lock'"
      ng-required="required"
      [disabled]="closingShift || (context | async)?.status !== ShiftStatus.Open"
      (click)="closeShift()"></button>
  </ng-template>
</p-dialog>
